import React from 'react';
import { styled } from '@stitches/react';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom'; // 暂时未使用

// 页面容器样式
const PageContainer = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '3rem'
});

// 标题区块样式
const HeaderSection = styled('section', {
  textAlign: 'center',
  marginBottom: '2rem'
});

// 标题样式
const Title = styled('h1', {
  fontSize: '2.5rem',
  fontWeight: 'bold',
  marginBottom: '1rem',
  color: '$textPrimary'
});

// 副标题样式
const Subtitle = styled('p', {
  fontSize: '1.2rem',
  maxWidth: '800px',
  margin: '0 auto',
  color: '$textSecondary',
  lineHeight: 1.6
});

// 支持选项网格样式
const SupportOptionsGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '2rem',
  marginBottom: '3rem'
});

// 支持选项卡片样式
const SupportOptionCard = styled('div', {
  background: '$backgroundSecondary',
  borderRadius: '12px',
  overflow: 'hidden',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
  
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)'
  }
});

// 支持选项图标容器样式
const SupportOptionIconContainer = styled('div', {
  width: '100%',
  padding: '2rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(135deg, $accentPrimary 0%, $accentSecondary 100%)',
  color: 'white',
  fontSize: '3rem'
});

// 支持选项内容样式
const SupportOptionContent = styled('div', {
  padding: '1.5rem'
});

// 支持选项标题样式
const SupportOptionTitle = styled('h3', {
  fontSize: '1.5rem',
  fontWeight: 'bold',
  marginBottom: '0.75rem',
  color: '$textPrimary'
});

// 支持选项描述样式
const SupportOptionDescription = styled('p', {
  fontSize: '1rem',
  color: '$textSecondary',
  marginBottom: '1.5rem',
  lineHeight: 1.6
});

// 链接按钮样式
const LinkButton = styled('a', {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.75rem 1.5rem',
  background: '$accentPrimary',
  color: 'white',
  borderRadius: '8px',
  textDecoration: 'none',
  fontWeight: 'bold',
  fontSize: '0.9rem',
  transition: 'all 0.2s ease',
  
  '&:hover': {
    opacity: 0.9,
    transform: 'translateY(-2px)'
  },
  
  '&::after': {
    content: '"→"',
    marginLeft: '0.5rem',
    fontSize: '1.1rem'
  }
});

// 部分标题样式
const SectionTitle = styled('h2', {
  fontSize: '2rem',
  fontWeight: 'bold',
  marginBottom: '1.5rem',
  color: '$textPrimary'
});

// 自助服务区块样式
const SelfServiceSection = styled('section', {
  marginBottom: '3rem'
});

// 自助链接网格样式
const SelfServiceLinksGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '1.5rem'
});

// 自助链接项样式
const SelfServiceLinkItem = styled('a', {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  padding: '1.5rem',
  background: '$backgroundSecondary',
  borderRadius: '8px',
  textDecoration: 'none',
  transition: 'all 0.2s ease',
  
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.05)'
  }
});

// 自助链接图标样式
const SelfServiceLinkIcon = styled('span', {
  fontSize: '1.5rem',
  color: '$accentPrimary'
});

// 自助链接文本样式
const SelfServiceLinkText = styled('span', {
  fontSize: '1rem',
  fontWeight: 'bold',
  color: '$textPrimary'
});

// 问题表单区块样式
const SupportFormSection = styled('section', {
  marginBottom: '3rem',
  padding: '2rem',
  background: '$backgroundSecondary',
  borderRadius: '12px'
});

// 表单样式
const SupportForm = styled('form', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem'
});

// 表单组样式
const FormGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem'
});

// 标签样式
const Label = styled('label', {
  fontSize: '1rem',
  fontWeight: 'bold',
  color: '$textPrimary'
});

// 输入框样式
const Input = styled('input', {
  padding: '0.875rem',
  borderRadius: '8px',
  border: '1px solid $borderColor',
  background: '$backgroundPrimary',
  fontSize: '1rem',
  color: '$textPrimary',
  
  '&:focus': {
    outline: 'none',
    borderColor: '$accentPrimary'
  }
});

// 文本域样式
const Textarea = styled('textarea', {
  padding: '0.875rem',
  borderRadius: '8px',
  border: '1px solid $borderColor',
  background: '$backgroundPrimary',
  fontSize: '1rem',
  color: '$textPrimary',
  minHeight: '150px',
  resize: 'vertical',
  
  '&:focus': {
    outline: 'none',
    borderColor: '$accentPrimary'
  }
});

// 选择框样式
const Select = styled('select', {
  padding: '0.875rem',
  borderRadius: '8px',
  border: '1px solid $borderColor',
  background: '$backgroundPrimary',
  fontSize: '1rem',
  color: '$textPrimary',
  
  '&:focus': {
    outline: 'none',
    borderColor: '$accentPrimary'
  }
});

// 提交按钮样式
const SubmitButton = styled('button', {
  padding: '1rem 2rem',
  background: '$accentPrimary',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  fontSize: '1rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  
  '&:hover': {
    opacity: 0.9,
    transform: 'translateY(-2px)'
  }
});

// 常见问题区块样式
const FaqSection = styled('section', {
  marginBottom: '3rem'
});

// 问题列表样式
const FaqList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem'
});

// 问题项样式
const FaqItem = styled('div', {
  border: '1px solid $borderColor',
  borderRadius: '8px',
  overflow: 'hidden'
});

// 问题样式
const FaqQuestion = styled('div', {
  padding: '1.25rem',
  background: '$backgroundTertiary',
  fontWeight: 'bold',
  color: '$textPrimary',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});

// 问题扩展符号样式
const FaqToggle = styled('span', {
  fontSize: '1.25rem',
  lineHeight: 1
});

// 答案样式
const FaqAnswer = styled('div', {
  padding: '1.25rem',
  background: '$backgroundSecondary',
  color: '$textSecondary',
  fontSize: '1rem',
  lineHeight: 1.6,
  borderTop: '1px solid $borderColor'
});

// 联系卡片网格样式
const ContactCardsGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '2rem'
});

// 联系卡片样式
const ContactCard = styled('div', {
  padding: '2rem',
  background: '$backgroundSecondary',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '1rem'
});

// 联系卡片图标样式
const ContactCardIcon = styled('div', {
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  background: 'rgba(6, 214, 160, 0.1)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1.5rem',
  color: '$accentPrimary',
  marginBottom: '0.5rem'
});

// 联系卡片标题样式
const ContactCardTitle = styled('h3', {
  fontSize: '1.25rem',
  fontWeight: 'bold',
  color: '$textPrimary'
});

// 联系卡片内容样式
const ContactCardContent = styled('p', {
  fontSize: '1rem',
  color: '$textSecondary',
  marginBottom: '1rem'
});

// 联系卡片链接样式
const ContactCardLink = styled('a', {
  color: '$accentPrimary',
  fontWeight: 'bold',
  textDecoration: 'none',
  
  '&:hover': {
    textDecoration: 'underline'
  }
});

/**
 * Kipa钱包支持页面组件
 * 提供用户支持、常见问题和联系方式
 */
const KipaWalletSupport: React.FC = () => {
  const { t } = useTranslation();
  
  // 支持选项数据
  const supportOptions = [
    {
      icon: '📚',
      title: t('kipaWallet.support.helpCenter.title', '帮助中心'),
      description: t('kipaWallet.support.helpCenter.description', '浏览我们详细的文档、教程和常见问题解答，快速解决您的问题。'),
      link: '#help-center'
    },
    {
      icon: '🛠️',
      title: t('kipaWallet.support.troubleshooting.title', '故障排除'),
      description: t('kipaWallet.support.troubleshooting.description', '遇到技术问题？使用我们的故障排除工具诊断和解决常见问题。'),
      link: '#troubleshooting'
    },
    {
      icon: '💬',
      title: t('kipaWallet.support.liveChat.title', '实时聊天'),
      description: t('kipaWallet.support.liveChat.description', '与我们的支持团队实时聊天，获取即时帮助和问题解决方案。'),
      link: '#live-chat'
    },
    {
      icon: '✉️',
      title: t('kipaWallet.support.contactUs.title', '联系我们'),
      description: t('kipaWallet.support.contactUs.description', '发送支持请求或者问题报告，我们的团队会尽快回复您。'),
      link: '#contact-form'
    }
  ];
  
  // 自助服务链接数据
  const selfServiceLinks = [
    {
      icon: '📋',
      text: t('kipaWallet.support.selfService.userGuide', '用户指南'),
      link: '#user-guide'
    },
    {
      icon: '🔍',
      text: t('kipaWallet.support.selfService.searchKnowledgeBase', '搜索知识库'),
      link: '#knowledge-base'
    },
    {
      icon: '📱',
      text: t('kipaWallet.support.selfService.setupGuide', '钱包设置指南'),
      link: '#setup-guide'
    },
    {
      icon: '🔒',
      text: t('kipaWallet.support.selfService.securityTips', '安全使用技巧'),
      link: '#security-tips'
    },
    {
      icon: '💰',
      text: t('kipaWallet.support.selfService.transactionHelp', '交易指南'),
      link: '#transaction-help'
    },
    {
      icon: '🔄',
      text: t('kipaWallet.support.selfService.recoveryGuide', '钱包恢复指南'),
      link: '#recovery-guide'
    }
  ];
  
  // 常见问题数据
  const faqs = [
    {
      question: t('kipaWallet.support.faq.recoveryPhrase.question', '如何备份和恢复我的钱包？'),
      answer: t('kipaWallet.support.faq.recoveryPhrase.answer', '首次创建钱包时，系统会提供一组12-24个单词的助记词。您应该将这些单词按顺序记录在安全的地方（最好是离线）。如果您需要恢复钱包，只需在Kipa钱包应用中选择"恢复钱包"选项，然后输入您的助记词即可。请记住，任何获取您助记词的人都可以控制您的加密资产，所以务必安全保管。')
    },
    {
      question: t('kipaWallet.support.faq.transaction.question', '为什么我的交易一直未确认？'),
      answer: t('kipaWallet.support.faq.transaction.answer', '交易确认时间取决于区块链网络的拥堵程度和您设置的矿工费。如果您的交易长时间未被确认，可能是因为设置的矿工费太低。在Kipa钱包中，您可以尝试使用"加速交易"功能增加矿工费，或者等待网络拥堵缓解。不同区块链的确认时间也有所不同，比如比特币通常需要更长的确认时间。')
    },
    {
      question: t('kipaWallet.support.faq.tokens.question', '为什么我在钱包中看不到某些代币？'),
      answer: t('kipaWallet.support.faq.tokens.answer', '如果您看不到某些代币，可能需要手动添加这些代币。在Kipa钱包中，进入代币列表页面，点击"添加代币"，然后输入代币合约地址。如果是较新或较小的代币，可能需要手动添加。另外，请确保您查看的是正确的网络（如以太坊、BSC等），因为不同网络的代币是独立显示的。')
    },
    {
      question: t('kipaWallet.support.faq.fees.question', '如何设置合适的交易手续费？'),
      answer: t('kipaWallet.support.faq.fees.answer', 'Kipa钱包提供自动和手动两种设置交易手续费的方式。在自动模式下，系统会根据当前网络状况推荐合适的费用设置。在手动模式下，您可以自定义费用。一般来说，费用越高交易确认越快，但成本也越高。在网络不拥堵时，选择标准或经济选项通常也能在合理时间内完成确认。')
    },
    {
      question: t('kipaWallet.support.faq.dapps.question', '如何连接DApp并确保安全？'),
      answer: t('kipaWallet.support.faq.dapps.answer', '在Kipa钱包中，您可以通过内置的DApp浏览器或外部浏览器连接DApp。使用时请注意安全：1）确保访问的是官方网站，检查URL；2）查看连接请求的权限，不要批准可疑的权限请求；3）如果DApp要求您签署交易，仔细检查交易细节；4）不要与未知或可疑的DApp连接；5）完成使用后主动断开连接。')
    }
  ];
  
  // 联系方式数据
  const contactMethods = [
    {
      icon: '📧',
      title: t('kipaWallet.support.contact.email.title', '电子邮件'),
      content: t('kipaWallet.support.contact.email.content', '发送详细问题描述，我们会在24小时内回复'),
      link: 'support@kipawallet.com',
      linkText: 'support@kipawallet.com'
    },
    {
      icon: '💬',
      title: t('kipaWallet.support.contact.chat.title', '实时聊天'),
      content: t('kipaWallet.support.contact.chat.content', '工作时间: 周一至周五 9:00 - 21:00'),
      link: '#live-chat',
      linkText: t('kipaWallet.support.contact.chat.linkText', '开始聊天')
    },
    {
      icon: '🌐',
      title: t('kipaWallet.support.contact.community.title', '社区支持'),
      content: t('kipaWallet.support.contact.community.content', '加入我们的社区获取用户间互助'),
      link: '#community',
      linkText: t('kipaWallet.support.contact.community.linkText', '加入社区')
    }
  ];
  
  return (
    <PageContainer>
      <HeaderSection>
        <Title>{t('kipaWallet.support.title', '客户支持与帮助')}</Title>
        <Subtitle>
          {t('kipaWallet.support.subtitle', '获取您需要的支持和资源，解决Kipa钱包使用中的问题')}
        </Subtitle>
      </HeaderSection>
      
      <SupportOptionsGrid>
        {supportOptions.map((option, index) => (
          <SupportOptionCard key={index}>
            <SupportOptionIconContainer>{option.icon}</SupportOptionIconContainer>
            <SupportOptionContent>
              <SupportOptionTitle>{option.title}</SupportOptionTitle>
              <SupportOptionDescription>{option.description}</SupportOptionDescription>
              <LinkButton href={option.link}>
                {t('kipaWallet.support.viewMore', '查看更多')}
              </LinkButton>
            </SupportOptionContent>
          </SupportOptionCard>
        ))}
      </SupportOptionsGrid>
      
      <SelfServiceSection>
        <SectionTitle>{t('kipaWallet.support.selfService.title', '自助服务')}</SectionTitle>
        <SelfServiceLinksGrid>
          {selfServiceLinks.map((link, index) => (
            <SelfServiceLinkItem key={index} href={link.link}>
              <SelfServiceLinkIcon>{link.icon}</SelfServiceLinkIcon>
              <SelfServiceLinkText>{link.text}</SelfServiceLinkText>
            </SelfServiceLinkItem>
          ))}
        </SelfServiceLinksGrid>
      </SelfServiceSection>
      
      <FaqSection id="faq">
        <SectionTitle>{t('kipaWallet.support.faq.title', '常见问题')}</SectionTitle>
        <FaqList>
          {faqs.map((faq, index) => (
            <FaqItem key={index}>
              <FaqQuestion>
                {faq.question}
                <FaqToggle>+</FaqToggle>
              </FaqQuestion>
              <FaqAnswer>
                {faq.answer}
              </FaqAnswer>
            </FaqItem>
          ))}
        </FaqList>
      </FaqSection>
      
      <SupportFormSection id="contact-form">
        <SectionTitle>{t('kipaWallet.support.contactForm.title', '提交支持请求')}</SectionTitle>
        <SupportForm>
          <FormGroup>
            <Label htmlFor="name">{t('kipaWallet.support.contactForm.name', '姓名')}</Label>
            <Input type="text" id="name" aria-label={t('kipaWallet.support.contactForm.name', '姓名')} />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="email">{t('kipaWallet.support.contactForm.email', '电子邮件')}</Label>
            <Input type="email" id="email" aria-label={t('kipaWallet.support.contactForm.email', '电子邮件')} />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="issue-type">{t('kipaWallet.support.contactForm.issueType', '问题类型')}</Label>
            <Select id="issue-type" aria-label={t('kipaWallet.support.contactForm.issueType', '问题类型')}>
              <option value="account">{t('kipaWallet.support.contactForm.issueTypes.account', '账户问题')}</option>
              <option value="transaction">{t('kipaWallet.support.contactForm.issueTypes.transaction', '交易问题')}</option>
              <option value="security">{t('kipaWallet.support.contactForm.issueTypes.security', '安全问题')}</option>
              <option value="feature">{t('kipaWallet.support.contactForm.issueTypes.feature', '功能请求')}</option>
              <option value="other">{t('kipaWallet.support.contactForm.issueTypes.other', '其他')}</option>
            </Select>
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="description">{t('kipaWallet.support.contactForm.description', '问题描述')}</Label>
            <Textarea 
              id="description" 
              aria-label={t('kipaWallet.support.contactForm.description', '问题描述')}
              placeholder={t('kipaWallet.support.contactForm.descriptionPlaceholder', '请详细描述您遇到的问题...')}
            />
          </FormGroup>
          
          <SubmitButton type="submit">
            {t('kipaWallet.support.contactForm.submit', '提交请求')}
          </SubmitButton>
        </SupportForm>
      </SupportFormSection>
      
      <section>
        <SectionTitle>{t('kipaWallet.support.contact.title', '联系我们')}</SectionTitle>
        <ContactCardsGrid>
          {contactMethods.map((method, index) => (
            <ContactCard key={index}>
              <ContactCardIcon>{method.icon}</ContactCardIcon>
              <ContactCardTitle>{method.title}</ContactCardTitle>
              <ContactCardContent>{method.content}</ContactCardContent>
              <ContactCardLink href={method.link}>{method.linkText}</ContactCardLink>
            </ContactCard>
          ))}
        </ContactCardsGrid>
      </section>
    </PageContainer>
  );
};

export default KipaWalletSupport; 